/**
 * Copyright © 2026 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function DisconnectPage() {
    const [status, setStatus] = useState("loading");
    const location = useLocation();
    const navigate = useNavigate();
    const getRilletUserIdFromQuery = () => {
        const params = new URLSearchParams(location.search);
        return params.get("rilletUserId");
    };

    useEffect(() => {

        const disconnect = async () => {
            try {
                const rilletUserId = getRilletUserIdFromQuery();
                if (!rilletUserId) {
                    setStatus("error");
                    return;
                }
                const disconnectUrl = `${process.env.REACT_APP_CONNECTOR_API_URL}/api/revoke?tenantId=${rilletUserId}&revokeQboTokens=false`;

                const response = await fetch(disconnectUrl,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json"
                        },
                    }
                );

                if (response.ok) {
                    navigate(`/integration`);
                } else {
                    setStatus("error");
                }
            } catch (err) {
                console.error("Error during disconnect:", err);
                setStatus("error");
            }
        };

        disconnect();
    }, [location.search]);

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100vh"
        >
            {status === "loading" && <CircularProgress />}            
            {status === "error" && (
                <>
                    <Typography variant="h6" color="error">
                        Something went wrong while disconnecting.
                    </Typography>                  
                </>
            )}
        </Box>
    );
}

export default DisconnectPage;
